React = require 'react'
t = require('views/internal/recup-with-helpers')('org_account')

module.exports = class extends React.Component
  displayName: 'RestrictionsComponent'

  render: t.renderable ->
    { orgInviteRestrict } = @props

    t.div '.setting-item-detail', ->
      t.div '.markeddown', ->
        if orgInviteRestrict is undefined
          t.format 'let-team-admins-decide'
        else
          if orgInviteRestrict.length
            t.p ->
              t.format 'only-people-with-these-email-domains-can-join-organizations'
            t.ul ->
              for restriction in orgInviteRestrict
                t.li ->
                  t.strong ->
                    t.text restriction



// WEBPACK FOOTER //
// ./app/scripts/views/enterprise/dashboard/teams-settings/restrictions-component.coffee